import React from "react";

function SectionTitle({
  title,
  subtitle
}) {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: "60px"
      }}
    >
      <h2
        style={{
          fontSize: "clamp(2rem,4vw,3.5rem)",
          fontFamily:
            "Playfair Display, serif",
          color: "#1d1d1f",
          marginBottom: "20px"
        }}
      >
        {title}
      </h2>

      {subtitle && (
        <p
          style={{
            maxWidth: "750px",
            margin: "0 auto",
            color: "#6e6e73",
            lineHeight: 1.8,
            fontSize: "1.1rem"
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default SectionTitle;